const generalActionTypes = {
  FETCH_REGISTER_FORM_SUBMISSION: 'FETCH_REGISTER_FORM_SUBMISSION',
  FETCH_REGISTER_FORM_SUBMISSION_SUCCESS: 'FETCH_REGISTER_FORM_SUBMISSION_SUCCESS',
  FETCH_REGISTER_FORM_SUBMISSION_FAIL: 'FETCH_REGISTER_FORM_SUBMISSION_FAIL',
};

export default generalActionTypes;
